import { render, staticRenderFns } from "./emailTemplateCreate.vue?vue&type=template&id=89160564&"
import script from "./emailTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./emailTemplateCreate.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplateCreate.vue?vue&type=style&index=0&id=89160564&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports